import { useEffect, useState } from "react"
import { getDownloadURL, ref, type FirebaseStorage } from "firebase/storage"
import { Spinner } from "react-bootstrap"

export const FirebaseAudioPlayer = (p: {
  storage: FirebaseStorage
  path: string
}) => {
  const [value, setValue] = useState<string | "loading" | Error>("loading")

  useEffect(() => {
    const fetchDownloadUrl = async () => {
      try {
        const url = await getDownloadURL(ref(p.storage, p.path))
        setValue(url)
      } catch (err) {
        console.error(err)
        setValue(err as Error)
      }
    }

    void fetchDownloadUrl()
  }, [p.storage, p.path])

  if (value === "loading") {
    return <Spinner />
  }

  if (typeof value === "object") {
    return <span className="text-danger">エラー: ファイルの読み込みに失敗しました。{value.message}</span>
  }

  return (
    <div>
      <audio controls src={value} />
    </div>
  )
}
